import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { MainNavService } from '@app/menu/services/main-nav.service';
import { BootstrapViewport } from '@app/utils/viewport';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'portal-main-nav-toggle',
  templateUrl: './main-nav-toggle.component.html',
  host: {
    class: 'main-nav__toggle',
  },
  standalone: false,
})
export class MainNavToggleComponent implements OnDestroy, OnInit {
  public currentPortalVersion: string;

  constructor(private mainNavService: MainNavService) {}

  ngOnDestroy(): void {}

  ngOnInit() {
    this.currentPortalVersion = environment.version;
  }

  @HostListener('click')
  onClick() {
    if (BootstrapViewport.isDesktop()) {
      this.mainNavService.toggleMainNav();
    }
  }
}
